import { useRouter } from 'next/router';
import Head from 'next/head';
import Link from 'next/link';
import ItemDetailView from '@/components/ItemDetailView';

export default function ItemDetailPage() {
  const router = useRouter();
  const { id } = router.query;

  // Handle loading state while router is initializing
  if (!id || typeof id !== 'string') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <>
      <Head>
        <title>Product Details | Sizzle</title>
        <meta name="description" content="View product details and information" />
      </Head>
      <div className="bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <ItemDetailView id={id} showComments showReactions />
        </div>
      </div>
    </>
  );
}
